var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoggedIn)?_c('div',{staticClass:"auth-wrap text-center"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }